import withLazyLoad from './withLazyLoad'

export default withLazyLoad
